import React from "react";
import styles from "./Spacing.module.css";

export default function Spacing({ s = "both", children }) {
  return <div className={styles[`spacing-${s}`]}>{children}</div>;
}
